// extracted by mini-css-extract-plugin
export default {"TabSubgroup":"TabSubgroup__TabSubgroup___S8qW8","open":"TabSubgroup__open___d2l7J","inner":"TabSubgroup__inner___B6RyB","activeTab":"TabSubgroup__activeTab___Foyi8"};